var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgClose(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M23.3737 10.0404C23.7642 9.64983 23.7642 9.01667 23.3737 8.62615C22.9832 8.23562 22.35 8.23562 21.9595 8.62615L15.9999 14.5857L10.0404 8.62615C9.64983 8.23562 9.01667 8.23562 8.62615 8.62615C8.23562 9.01667 8.23562 9.64983 8.62615 10.0404L14.5857 15.9999L8.62615 21.9595C8.23562 22.35 8.23562 22.9832 8.62615 23.3737C9.01667 23.7642 9.64983 23.7642 10.0404 23.3737L15.9999 17.4141L21.9595 23.3737C22.35 23.7642 22.9832 23.7642 23.3737 23.3737C23.7642 22.9832 23.7642 22.35 23.3737 21.9595L17.4141 15.9999L23.3737 10.0404Z",
    fill: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgClose);
export default __webpack_public_path__ + "static/media/close.6855894543bd4f8426846ea6d8eabf77.svg";
export { ForwardRef as ReactComponent };